import React from "react";
import useFetchURL from "../../../../components/Hooks/useFetchURL";
import { uri } from "../../../../help/Api";
import useFormDataCRUD from "../../../../components/Hooks/useEDSCURD";
import API from "../../../../api/UsersCURD";
import User from "./user";
import { useEffect } from "react";
import { insh, sto } from "../../../../Context/InshData";
import LoadingPage from "../../../../services/LoadingPage";
import useFetchObjectByPost from "../../../../components/Hooks/useFetchObjectByPost";

export default function UserCon() {
  const tb = {
    wait: true,
    costcenters: true,
    salesmen: true,
    Bank: true,
    stor: sto,
    parms: { branch: sto.branchi, db_name: sto?.db_name },
  };

  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb,
  );
  let Urls = null;
  if (sto.db_name === "" || sto.db_name === null) {
    Urls = `?userId=${sto.idi}`
  } else {
    Urls = `?userId=${sto.idi}&&db_name=${sto?.db_name}`
  }
  const { data, fetching, fetchURL } = useFetchURL({
    ...{
      url: API.URL +Urls,
    },
  });

  // const {object:data, fetching: fetchinData, fetch:fetchURL} =  useFetchObjectByPost(url, tb);
  useEffect(() => {
    console.log("uers is", data);
  });

  if (fetching || !AutoOptions?.center || !data?.length > 0) return <LoadingPage />;

  return (
    <User
      {...{
        data,
        fetchURL,
        AutoOptions
      }}
    />
  );
}
